import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import './lib/i18n'
import { PostHogProvider } from 'posthog-js/react'
import { registerSW } from 'virtual:pwa-register'

const options = {
  api_host: '/sylva-relay/',
  ui_host: 'https://eu.posthog.com',
  disable_surveys: true,
}

// Silently register the service worker early (also on /auth)
registerSW({});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PostHogProvider apiKey="phc_AN7TpDZYPNywcsdX9NoKiTuku0tig6HTtdrPdUYTArG" options={options}>
      <App />
    </PostHogProvider>
  </StrictMode>,
);
